import {
  BUSNQuestionService,
  BUSNQuoteScheduleService,
  BUSNRenewalService,
  BUSNUserService,
} from '@takectrl-multiapp/svcs-core-business';
import { Component, Input, EventEmitter, Output, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import {
  SharedConfig,
  AssetType,
  ISchedule,
  SharedDialogService,
  QuoteRequestType,
  QuoteRequestStatusType,
  IRenewal,
  IUserAllRelatedData,
  SharedFormulaService,
} from '@takectrl-multiapp/svcs-share-config';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import '@lottiefiles/lottie-player';
import { PageType } from 'libs/svcs-share-config/src/lib/types/page.type';
import { ICtrlResponse } from 'libs/svcs-ctrl-api/src/lib/interfaces/api.interface';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';

declare const dataLayer: any[];

@Component({
  selector: 'wallet',
  standalone: false,
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss'],
})
export class WalletComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() asset_type: AssetType;
  @Output() navigateForwardToPage: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateRootToToPage: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateAssetPage: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateRenewalPage: EventEmitter<unknown> = new EventEmitter();
  @Output() navigatePersonalDetails: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateEndorsementAcceptPage: EventEmitter<unknown> = new EventEmitter();
  @Output()
  navigateQuotePage: EventEmitter<unknown> = new EventEmitter();
  @Output() navigateQuoteNew: EventEmitter<unknown> = new EventEmitter<unknown>();
  showSHit = false;
  showAn = true;
  password: string;
  kpPopup = true;
  public pendingEndorsementSchedule: ISchedule;
  public endorsementUpdate: boolean;
  public enableSetPasswordButton = false;
  @Input() showRegisterSuccess: boolean;
  animationSrc = '../assets/lottie-animations/successful-register.json';
  sub_heading = 'First up, let’s complete the rest of your personal details.';
  isAllAssetsComplete: boolean;
  popupRestartQuote = false;
  popupHeader: string;
  popupMessage: string;
  QuoteRequestStatusType = QuoteRequestStatusType;
  QuoteRequestType = QuoteRequestType;
  AssetType = AssetType;
  directInsurers: Array<string> = [];

  constructor(
    public sharedConfig: SharedConfig,
    private readonly busnRenewalService: BUSNRenewalService,
    public busnThirdPartyService: BUSNThirdPartyService,
    private readonly sharedDialogService: SharedDialogService,
    public busnQuestionService: BUSNQuestionService,
    public busnUserService: BUSNUserService,
    public busnQuoteScheduleService: BUSNQuoteScheduleService,
    private readonly busnCommService: BUSNCommunicationService,
    public sharedFormulaService: SharedFormulaService
  ) {
    SharedConfig.selectedPage = PageType.wallet;
    this.openIntercomChat = this.openIntercomChat.bind(this);
    this.logout = this.logout.bind(this);
    this.newEndorsement = this.newEndorsement.bind(this);
    this.newQuoteRequest = this.newQuoteRequest.bind(this);
  }

  async ngOnInit(): Promise<void> {
    dataLayer.push({
      event: 'page_show',
      screenPath: 'wallet',
      screenName: 'wallet',
      userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
    });
    this.checkIfWaitingOnQuoteToBeAccepted();
    this.checkIfQuoteRequestsAreInAndReadyToCompare();
    this.openChat = this.openChat.bind(this);
    this.newEndorsement = this.newEndorsement.bind(this);
  }

  createDirectInsurersArray() {
    let listOfDirectInsurers = this.sharedConfig.schedulesActive?.filter(
      (x) => x.insurer_id === 'MIWAY' || x.insurer_id === 'KINGPRICE' || x.insurer_id === 'SANTAMDIRECT'
    );
    if (listOfDirectInsurers && listOfDirectInsurers.length > 0) {
      for (let insurer of listOfDirectInsurers) {
        this.directInsurers.push(insurer.insurer_description, ' or ');
      }
    }
    this.directInsurers.pop();
  }

  async checkIfQuoteRequestsAreInAndReadyToCompare() {
    if (
      SharedConfig.doRouteCheck &&
      (!this.sharedConfig.schedulesActive || this.sharedConfig.schedulesActive.length <= 0) &&
      this.sharedConfig?.userPermissions?.can_quote &&
      this.sharedConfig.quoteRequest &&
      this.sharedConfig.quoteRequest?.status !== QuoteRequestStatusType.WaitingOnInsurer &&
      this.sharedConfig.quoteRequest?.type === QuoteRequestType.Quote
    ) {
      this.navigateRootToToPage.emit('home/home-quote');
    } else {
      SharedConfig.doRouteCheck = true;
      this.createDirectInsurersArray();
      await this.doShowOnTrackDialogCheck();
    }
  }

  

  async ngAfterViewInit() {
    await this.checkPremUpdate();
  }

  showEndorsementFailedAlert() {
    let quote_request_stored_id = localStorage.getItem('quote_request_stored_id');
    let has_seen_endorsement_failed_alert = localStorage.getItem('has_seen_endorsement_failed_alert');
    if (has_seen_endorsement_failed_alert === 'true') {
      if (this.sharedConfig.quoteRequest && this.sharedConfig.quoteRequest.status === QuoteRequestStatusType.Failed && (this.sharedConfig.quoteRequest?.type === QuoteRequestType.EndorsementAdd || this.sharedConfig.quoteRequest?.type === QuoteRequestType.EndorsementUpdate) && this.sharedConfig.quoteRequest.id.toString() === quote_request_stored_id) {
        return false 
      } else {
        localStorage.removeItem('has_seen_endorsement_failed_alert');
        return true
      }
    } else {
      localStorage.removeItem('has_seen_endorsement_failed_alert');
      return true;
    }
  }

  closeEndorsementFailedAlert() {
    localStorage.setItem('quote_request_stored_id', this.sharedConfig.quoteRequest.id.toString());
    localStorage.setItem('has_seen_endorsement_failed_alert', 'true');
    this.showEndorsementFailedAlert()
  }

  private async doShowOnTrackDialogCheck() {
    this.sharedConfig.setShowCustomLoader(true);
    await this.busnUserService.doQuoteRequestDetailsRun();
    const schedules: Array<ISchedule> = await this.busnQuoteScheduleService.getAllActiveSchedules();
    if ( schedules?.length > 0) {
      SharedConfig.showFooterTabs = true;
    }

    if (
      (this.sharedConfig.quoteRequest &&
        (this.sharedConfig.quoteRequest.status === QuoteRequestStatusType.Pending) &&
        this.sharedConfig.quoteRequest.type === QuoteRequestType.Quote) ||
      (schedules &&
        schedules?.length === 1 &&
        schedules[0].status !== 'ACTIVE' &&
        !SharedConfig.showOnTrackPopup)
    ) {
      console.log('Polling check - Starting:');
      SharedConfig.showOnTrackPopup = true;
      SharedConfig.showFooterTabs = false;
      this.showOnTrackDialog();
      this.startPollingTimer();
    }
    else {
      SharedConfig.showFooterTabs = schedules?.length > 0;
    }
    if ( schedules?.length > 0) {
      this.checkForUserRenewals();
    }
    this.sharedConfig.setShowCustomLoader(false);
    
  }

  showOnTrackDialog() {
    this.sharedDialogService.showPopupDialog({
      header: 'On track',
      subHeader:
        'Your policy has been activated and you are now covered! We are busy updating your app to reflect your new policy. We should be done in a minute.',
      buttonOneText: 'Contact us',
      buttonOneCallback: this.openIntercomChat,
      buttonTwoText: 'Logout',
      buttonTwoCallback: this.logout,
    });
  }

  private startPollingTimer() {
    const timer = setInterval(async () => {
      if (!SharedConfig.showOnTrackPopup) {
        clearInterval(timer);
        return;
      }

      // Check if schedules are now available
      await this.busnUserService.doQuoteRequestDetailsRun();
      const schedules: Array<ISchedule> = await this.busnQuoteScheduleService.getAllActiveSchedules();
      console.log('Polling check - Latest Quote Request:', this.sharedConfig.quoteRequest);
      console.log('Polling check - Schedules:', schedules);

      if (
        !(
          (this.sharedConfig.quoteRequest &&
            (this.sharedConfig.quoteRequest.status === QuoteRequestStatusType.Pending || this.sharedConfig.quoteRequest.status === QuoteRequestStatusType.WaitingOnInsurer) &&
            this.sharedConfig.quoteRequest.type === QuoteRequestType.Quote) ||
          (schedules &&
            schedules?.length === 1 &&
            schedules[0].status !== 'ACTIVE' &&
            !SharedConfig.showOnTrackPopup)
        )
      ) {
        console.log('Stopping timer: Conditions no longer met');
        SharedConfig.showOnTrackPopup = false;
        SharedConfig.showFooterTabs = true;
        this.sharedDialogService.hidePopupDialog();
        clearInterval(timer);
      }
    }, 10000); // 10 seconds
  }

  ngOnDestroy() {
    SharedConfig.showOnTrackPopup = false; // This will trigger the timer to stop
  }

  async checkPremUpdate() {
    if (this.sharedConfig?.schedulesActive?.length > 0 && !SharedConfig.didCheckPremiumChange) {
      try {
        let result = await this.busnQuoteScheduleService.checkForUpdatedPremiums();
        if (result) {
          SharedConfig.didCheckPremiumChange = true;
        } else {
          SharedConfig.didCheckPremiumChange = false;
        }
      } catch (error) {
        SharedConfig.didCheckPremiumChange = false;
      }
    }
  }

  async compFloatingAction() {
    this.navigateRootToToPage.emit('ctrl-center');
  }

  // showFloatingButton() {
  //   const accessList = this.sharedConfig.appSettings?.ai_user_access_list;
  //   if (accessList?.includes(this.sharedConfig?.firebaseUser?.email)) {
  //     return true;
  //   } else return false;
  // }

  openIntercomChat() {
    this.busnCommService.openContactCardPopup()
  }

  scheduleBeingUpdated() {
    if (this.sharedConfig.schedulesActive && this.sharedConfig.schedulesActive[0]?.status === 'PENDING_ENDORSE') {
      return true;
    }
    return false;
  }

  async logout() {
    this.sharedDialogService.hidePopupDialog();
    await this.busnUserService.signOut();
    this.navigateRootToToPage.emit('public-landing');
    window.location.reload();
  }

  closeKpPopup() {
    this.kpPopup = false;
  }

  chatToUs() {
    this.kpPopup = false;
    this.busnCommService.openContactCardPopup()
  }

  async cancelQuoteRequest() {
    this.sharedConfig.setShowCustomLoader(true);
    await this.busnQuoteScheduleService.cancelQuoteRequest();
    this.sharedConfig.setShowCustomLoader(false);
  }

  checkIfWaitingOnQuoteToBeAccepted() {
    if (
      this.sharedConfig.schedulesActive &&
      SharedConfig.schedulesActiveInitialCount !== this.sharedConfig.schedulesActive.length &&
      !SharedConfig.scheduleHasBeenSetToActive &&
      SharedConfig.onTrackPopupHeader &&
      SharedConfig.onTrackPopupSubheading
    ) {
      this.sharedDialogService.showPopupDialog({
        header: SharedConfig.onTrackPopupHeader,
        subHeader: SharedConfig.onTrackPopupSubheading,
        buttonOneText: 'OK',
        buttonOneCallback: this.sharedDialogService.hidePopupDialog,
      });
    }
  }

  async checkForUserRenewals() {
    // (await this.loader).present();
    if (!SharedConfig.didViewRenewal) {
      this.busnRenewalService.checkForRenewal().then(async (renewal: ICtrlResponse<Array<IRenewal>>) => {
        SharedConfig.didViewRenewal = true;
        if (renewal && renewal.success && renewal?.results?.length > 0) {
          this.navigateRenewalPage.emit({ renewal: renewal });
        } else {
          console.log('There are no renewals to fetch');
        }
      });
    }
  }

  navFromRefPage(page: string) {
    if (page === 'personal-details') {
      this.navigatePersonalDetails.emit();
    } else {
      this.navigateRootToToPage.emit(page);
    }
  }

  getAssetTypeDetails(asset_type: AssetType): [number, string] {
    switch (asset_type) {
      case AssetType.Contents: {
        return [this.sharedConfig.schedulesPremiumDetails.contents_premium, AssetType.Contents];
      }
      case AssetType.AllRisks: {
        return [
          this.sharedConfig.schedulesPremiumDetails.all_risks_premium + this.sharedConfig.schedulesPremiumDetails.specified_items_premium,
          'all risk',
        ];
      }
      case AssetType.Buildings: {
        return [this.sharedConfig.schedulesPremiumDetails.buildings_premium, AssetType.Buildings];
      }
      case AssetType.Vehicles: {
        return [this.sharedConfig.schedulesPremiumDetails.vehicles_premium, AssetType.Vehicles];
      }
      case AssetType.Other: {
        return [this.sharedConfig.schedulesPremiumDetails.otherPremium, 'any other'];
      }
      case AssetType.Motorcycles: {
        return [this.sharedConfig.schedulesPremiumDetails.motorcycles_premium, AssetType.Motorcycles];
      }
      case AssetType.Caravans: {
        return [this.sharedConfig.schedulesPremiumDetails.caravans_premium, 'caravan/trailer'];
      }
      case AssetType.Vaps: {
        return [this.sharedConfig.schedulesPremiumDetails.vaps_premium, AssetType.Vaps];
      }
    }
  }

  assetSelected(asset_type: AssetType) {
    const assetSelectDetails = this.getAssetTypeDetails(asset_type);
    if (
      (this.sharedConfig.schedulesActive && this.sharedConfig.schedulesActive[0]?.status === 'PENDING_ENDORSE') ||
      this.sharedConfig.quoteRequest?.status === QuoteRequestStatusType.WaitingOnInsurer ||
      this.sharedConfig.quoteRequest?.status === QuoteRequestStatusType.Submitted ||
      this.sharedConfig.quoteRequest?.status === QuoteRequestStatusType.Pending
    ) {
      this.sharedDialogService.showPopupDialog({
        header: 'We are busy updating your policy.',
        buttonOneText: 'OK',
        buttonOneCallback: this.sharedDialogService.hidePopupDialog,
      });
    } else if (assetSelectDetails && assetSelectDetails[0] > 0) {
      this.navigateAssetPage.emit(asset_type);
    } else {
      this.sharedDialogService.showPopupDialog({
        header: `You don't have ${assetSelectDetails[1]} cover yet.`,
        subHeader: 'Add it to your policy by clicking on the “Insure something else” button at the bottom of this page.',
        buttonOneText: 'OK',
        buttonOneCallback: this.sharedDialogService.hidePopupDialog,
      });
    }
  }

  async startNewOrContinueEndorsement() {
    if (
      SharedConfig.quoteRequest &&
      SharedConfig?.quoteRequest?.type === QuoteRequestType.EndorsementAdd &&
      this.sharedConfig.schedulesActive.length === 1 &&
      (SharedConfig.quoteRequest.status === QuoteRequestStatusType.WaitingOnQuotes ||
        SharedConfig.quoteRequest.status === QuoteRequestStatusType.Submitted)
    ) {
      this.sharedDialogService.showPopupDialog({
        header: 'Hold on',
        subHeader: 'You have an open request to update your policy. Adding an asset will cancel this request, would you like to continue?',
        buttonOneText: 'Yes',
        buttonOneCallback: this.newEndorsement,
        buttonTwoText: 'No',
        buttonTwoCallback: this.sharedDialogService.hidePopupDialog,
      });
    } else if (this.sharedConfig.schedulesActive.length > 1) {
      this.sharedConfig.setShowCustomLoader(true);
      if (this.sharedConfig.schedulesActive.length > 1) {
        this.sharedDialogService.showPopupDialog({
          header: 'Hold on',
          subHeader: "We see that you have more than one policy with us. Let's chat to determine where to add the new asset(s).",
          buttonOneText: 'Contact us',
          buttonOneCallback: this.openChat,
          buttonTwoText: 'Cancel',
          buttonTwoCallback: this.sharedDialogService.hidePopupDialog,
        });
        this.sharedConfig.setShowCustomLoader(false);
      }
    } else if (this.sharedConfig.schedulesActive.find((x) => x.insurer_id === 'MIWAY' || x.insurer_id === 'KINGPRICE')) {
      this.sharedDialogService.showPopupDialog({
        header: 'Hold on',
        subHeader: 'Unfortunately your insurer does not allow changes to your policy via the app yet. Please chat to us for assistance.',
        buttonOneText: 'Contact us',
        buttonOneCallback: this.openChat,
        buttonTwoText: 'Cancel',
        buttonTwoCallback: this.sharedDialogService.hidePopupDialog,
      });
      this.sharedConfig.setShowCustomLoader(false);
    } else {
      SharedConfig.hideHeader = false;
      this.busnThirdPartyService.logEvent('action_endorsement_add_started');
      try {
        if (this.sharedConfig.quoteRequest && this.sharedConfig.quoteRequest.status === QuoteRequestStatusType.Open) {
          this.navigateQuoteNew.emit();
        } else {
          this.newEndorsement()
        }
      } catch (error) {
        this.sharedDialogService.showPopupDialog({
          header: 'Something went wrong!',
          subHeader: error.message,
          buttonOneText: 'OK',
          buttonOneCallback: this.sharedDialogService.hidePopupDialog,
        });
        this.sharedConfig.setShowCustomLoader(false);
      }
    }
  }

  newQuoteRequest() {
    this.sharedConfig.setShowCustomLoader(true);
    this.sharedDialogService.hidePopupDialog();
    this.busnQuoteScheduleService.createNewQuoteRequest().then(async (quoteRequest) => {
      this.sharedConfig.setShowCustomLoader(false);
      this.navigateQuoteNew.emit();
    });
  }

  newEndorsement() {
    this.sharedConfig.setShowCustomLoader(true);
    this.sharedDialogService.hidePopupDialog();
    this.busnQuoteScheduleService.createNewEndorsementRequest(QuoteRequestType.EndorsementAdd).then(async (quoteRequest) => {
      this.sharedConfig.setShowCustomLoader(false);
      this.navigateQuoteNew.emit();
    });
  }

  navToHomeQuote() {
    this.navigateForwardToPage.emit('home/home-quote');
  }

  navToHomeQuoteList() {
    this.navigateForwardToPage.emit('quote-list-retrieved-summary');
  }

  navQuotePage() {
    this.navigateQuotePage.emit();
  }

  async viewEndorsementAcceptPage() {
    this.navigateEndorsementAcceptPage.emit();
  }

  openChat() {
    this.sharedDialogService.hidePopupDialog();
    this.busnCommService.openContactCardPopup()
  }
}
